import { EApprovalStatus, EnumApprovalsTabs } from "src/app/models/approval.model";
import { EQuestionnaireStatus } from "src/app/models/questionnaireGrid.model";
import { EReplyStatus } from "src/app/models/recipients.model";
import { EnumExportStatus } from "src/app/models/report.model";
import { AmountRange } from "../components/amount-range-filter/amount-range-filter.component";

export interface FilterItemList {
    id: number;
    displayNameHe: string;
    displayNameEn: string;
    fieldName: string;
    typeFilter: EnumFilterType;
}

export enum PageTypeEnum {
    QuestionnairesList = 1, Reminders, DistributionGroups, SavedLists, Approvals
}

export enum EnumFilterType {
    RANGE = 1, NUMBER, AUTOCOMPLETE, MULTI, DATE, SINGLE_AUTOCOMPLETE
}

export interface SelectedFilter {
    creator?: number[];
    distributionDate?: DateRange;
    submissionDate?: DateRange;
    reminderDate?: DateRange;
    endDate?: DateRange;
    createDate?: DateRange;
    approvedDate?: DateRange;
    filterByName?: string;
    categoryId?: number;
    status?: EQuestionnaireStatus[];
    statusToUser?: EReplyStatus[];
    myQuestionnaires?: boolean;
    statusApproval?: EApprovalStatus[];
    generalQuestionnaires?: boolean;
    approvalsTabs?: EnumApprovalsTabs;
    approverIds?: number[];
    questionnaireNumber?: number;
    mlmExportStatus?: EnumExportStatus[];
    amount?: AmountRange;
    clientCharge?: boolean;
    // Reports tab "סטטוס טופס" multi-select. EReplyStatus (request-level), not EApprovalStatus
    // (single approval row) - see ReportRow.formStatus. Named formStatus, not approvalStatus, so it
    // cannot be mistaken for statusApproval above: a different filter, on a different enum, whose
    // name is the same two words in the other order.
    formStatus?: EReplyStatus[];
    // Reports tab date-range filters (see ReportRow.mlmLastExportDate / formApprovalDate).
    mlmLastExportDate?: DateRange;
    formApprovalDate?: DateRange;
    // After Approval tab "חודש שכר" multi-select: payroll months encoded yyyyMM (e.g. 202609),
    // plus PAYROLL_MONTH_NOT_TRANSFERRED for requests not yet exported to payroll.
    payrollMonths?: number[];
}

export const PAYROLL_MONTH_NOT_TRANSFERRED = 0;

export interface MetaDataOption {
    id: number,
    name: string,
    completed?: boolean
}

export enum DateRangeTypeEnum {
    Days7 = 1, Month1 = 2, Month12 = 3, CurrentYear = 4, LastYear = 5, Custom = 6
}

export interface DateRange {
    customDateFromNTZ?: Date
    customDateToNTZ?: Date
    dateRangeType: DateRangeTypeEnum
}

export interface DateRangeFilter {
    key: DateRangeTypeEnum,
    valueHe: string
    valueEn: string
}